(function () {
  function observeConfigurator(configurator) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle(
            "henk-configurator--in-view",
            entry.isIntersecting,
          );
        });
      },
      {
        threshold: 0.2,
      },
    );

    observer.observe(configurator);

    return observer;
  }

  function init() {
    const variantSwitcher = document.querySelector("henk-variant-switcher");

    // Sofa configurator: the configurator itself gets replaced.
    if (variantSwitcher) {
      let configurator = null;
      let observer = null;

      function findConfigurator() {
        const newConfigurator =
          variantSwitcher.querySelector(".henk-configurator");

        if (!newConfigurator || newConfigurator === configurator) return;

        observer?.disconnect();

        configurator = newConfigurator;
        observer = observeConfigurator(configurator);
      }

      findConfigurator();

      const mutationObserver = new MutationObserver(findConfigurator);

      mutationObserver.observe(variantSwitcher, {
        childList: true,
        subtree: true,
      });

      return;
    }

    // Other configurators: normal case.
    const configurator = document.querySelector(".henk-configurator");

    if (configurator) {
      observeConfigurator(configurator);
    }
  }

  init();
})();
